// src/components/layout/Footer.tsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import { useResponsive } from '@/hooks/useResponsive';
import styles from '@/styles/layout/Footer.module.css';

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation('translation');
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  
  // Используем хук useResponsive
  const responsive = useResponsive();
  const { isMobile, isTablet, isLandscape } = responsive;
  
  // Компактный режим для горизонтальной ориентации на мобильных
  const isCompactMode = isMobile && isLandscape;

  const languages = [
    { code: 'ru', name: t('language.ru') },
    { code: 'en', name: t('language.en') }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
    setIsLanguageOpen(false);
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={`${styles.content} ${isCompactMode ? styles.compact : ''}`}>
          <div className={styles.copyright}>
            {t('footer.copyright')}
          </div>
          
          {/* Секция для языка и контактов с адаптивной версткой */}
          <div className={styles.contactsSection}>
            <div className={styles.languageSelector}>
              <button 
                onClick={() => setIsLanguageOpen(!isLanguageOpen)}
                className={styles.languageButton}
                aria-label={t('language.change')}
                aria-expanded={isLanguageOpen}
              >
                {currentLanguage.name}
                <ChevronDown className={styles.languageIcon} />
              </button>
              {isLanguageOpen && (
                <div className={`${styles.languageDropdown}`}>
                  {languages.map(lang => (
                    <button
                      key={lang.code}
                      onClick={() => handleLanguageChange(lang.code)}
                      className={`
                        ${styles.languageDropdownItem}
                        ${currentLanguage.code === lang.code ? styles.languageDropdownItemActive : ''}
                      `}
                      aria-selected={currentLanguage.code === lang.code}
                    >
                      {lang.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
            
            {/* Контакты с адаптивным стилем */}
            <div className={styles.contactsLinks}>
              <a 
                href="mailto:info@rinnax.kz" 
                className={styles.contactLink}
              >
                info@rinnax.kz
              </a>
              <a 
                href="tel:+77777777777" 
                className={styles.contactLink}
              >
                +7 777 777 77 77
              </a>
            </div>
          </div>
        </div>
        
        {/* Отступ снизу для мобильных устройств с навигацией */}
        {(isMobile || isTablet) && (
          <div className={`${styles.mobileNavPadding} ${isCompactMode ? styles.compact : ''}`} />
        )}
      </div>
    </footer>
  );
};

export default Footer;